import type { SVGProps } from 'react';
const DawnFlagSN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-SN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-SN_svg__a)">
      <path fill="#F13642" d="M10.477 0h11.524v16H10.477z" />
      <path fill="#17A052" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#FFF166"
        fillRule="evenodd"
        d="M7.333 16h7.333V0H7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#17A052"
        fillRule="evenodd"
        d="m11 9.093-1.54 1.064.519-1.82-1.47-1.161 1.86-.06.63-1.783.632 1.782 1.86.06-1.47 1.163.518 1.82z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagSN;
